module.exports = __webpack_public_path__ + "img/AT0000002473328.e17499d7.png";